import React from "react";
import { StatusTags } from "../../components/common/registerUtils";
import { beautify } from "../../utils/helpers";

export const useStaffs = () => {
  const tableColumns = () => [
    {
      id: "first_name",
      header: "First Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "last_name",
      header: "Last Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "phone_number",
      header: "Phone Number",
      filter: {
        type: "text",
      },
    },
    {
      id: "email",
      header: "Email",
      filter: {
        type: "text",
      },
    },
    { id: "role", header: "Role", filter: { type: "text" } },
    {
      id: "user_status",
      header: "User Status",
      filter: {},
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        first_name: beautify(item?.first_name),
        last_name: beautify(item?.last_name),
        phone_number: item?.phone_number,
        email: item?.email,
        user_status: <StatusTags status={item?.user_status} />,
        username: item?.username,
      };
    }),
  ];

  return { tableColumns, tableData };
};
